import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    basicWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(12, 18),
    },
    title: {
      fontSize: "24px",
      fontWeight: 500,
      color: theme.primary800,
      textAlign: "center",
      whiteSpace: "break-spaces",
    },
    description: {
      color: theme.gray500,
      fontSize: "16px",
      fontWeight: 400,
      textAlign: "center",
      whiteSpace: "break-spaces",
    },
    iconWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      backgroundColor: theme.primary50,
      width: "44px",
      minWidth: "44px",
      height: "44px",
      "& svg": {
        color: theme.primary500,
        stroke: theme.primary500,
      },
    },
  }),
);
